import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const LOCAL_URL = `${backendUrl}/api/local/`;

class LocalService {
	async getAllLocals() {
		try {
			const response = await axios.get(LOCAL_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getLocal(id) {
		return axios.get(`${LOCAL_URL}${id}/`);
	}

	createLocal(data) {
		return axios.post(LOCAL_URL, data).catch((error) => {
			console.error('Erreur lors de la création du parent', error);
			throw error;
		});
	}

	updateLocal(id, data) {
		return axios.put(`${LOCAL_URL}${id}/`, data);
	}
	getLocalOptions() {
		return this.getAllLocals().then((locals) => {
			const options = locals.map((local) => ({
				value: local.id,
				label: local.nom.toUpperCase()
			}));
			// options.unshift({value: null, label: 'Selectionner le local'});
			return options;
		});
	}
	deleteLocal(id) {
		return axios.delete(`${LOCAL_URL}${id}/`);
	}
}

export default new LocalService();
